module.exports = __webpack_public_path__ + "img/banking-details.af6f953e.png";